import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=be82bf06"
var script = {}
import style0 from "./Limit.vue?vue&type=style&index=0&id=be82bf06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports